import { Component, Input } from '@angular/core';
import {
  TGFormControlQuestionDirective
} from '../form-control-question';

@Component({
  selector: 'tgf-form-input-question',
  templateUrl: './form-input-question.component.html',
  styleUrls: ['./form-input-question.component.scss']
})
export class FormInputQuestionComponent extends TGFormControlQuestionDirective {
  @Input() placeholder: string = '';
  @Input() prefix = undefined;
  @Input() suffix = undefined;
  @Input() mask: any;
  @Input() dropSpecialCharacters = true;
  @Input() thousandSeparator?: any;
  @Input() maxNumber: any;
  @Input() minNumber: any;
  @Input() maskMin: any;
  @Input() maskMax: any;

  override ngOnInit() {
    super.ngOnInit();
  }
}
